import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { GlobalSearchRecentsListHeadingStyled } from './styles/GlobalSearchRecentsListHeadingStyled'
import { GlobalSearchListbox } from '../../../../components/GlobalSearchListbox'
import { type GlobalSearchRecentItem } from '../../../../value-objects/GlobalSearchRecentItem'
import { GlobalSearchListItem } from '../GlobalSearchListItem'

interface IGlobalSearchRecentsListProps {
  listboxId: string
  items: GlobalSearchRecentItem[]
  highlightedIndex: Nullable<number>
  onRecentItemClick: (item: GlobalSearchRecentItem) => void
}

export const GlobalSearchRecentsList = ({
  listboxId,
  items,
  highlightedIndex,
  onRecentItemClick,
}: IGlobalSearchRecentsListProps) => {
  const intl = useProcurifyIntl()

  return (
    <>
      <GlobalSearchRecentsListHeadingStyled color='textSecondary'>
        {intl.formatMessage(messages.recentHeading)}
      </GlobalSearchRecentsListHeadingStyled>
      <GlobalSearchListbox
        id={listboxId}
        ariaLabel={intl.formatMessage(messages.listboxAriaLabel)}
        highlightedIndex={highlightedIndex}
      >
        {items.map((item, index) => (
          <GlobalSearchListItem
            key={item.uuid}
            uuid={item.uuid}
            type={item.type}
            id={item.id}
            metadata={item.metadata}
            isHighlighted={index === highlightedIndex}
            onClick={() => onRecentItemClick(item)}
          />
        ))}
      </GlobalSearchListbox>
    </>
  )
}
